import { render, staticRenderFns } from "./StuOpenClass.vue?vue&type=template&id=25903292&scoped=true&"
import script from "./stuopenclass.js?vue&type=script&lang=js&"
export * from "./stuopenclass.js?vue&type=script&lang=js&"
import style0 from "./StuOpenClass.vue?vue&type=style&index=0&id=25903292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25903292",
  null
  
)

export default component.exports